import { FiRrInfo } from '@app/assets';
import { useActivePlan } from '@app/domain/plan/hooks/useActivePlan';
import { Trans } from 'react-i18next';

export const TrialProgressBanner: React.FC = () => {
  const { totalTrialDays, daysSinceStart } = useActivePlan();
  return (
    <div className="mx-6 md:mx-0 flex gap-3 items-start rounded-lg bg-gray-100 border border-gray-300 px-3 py-2">
      <FiRrInfo className="text-error shrink-0" />
      <div className="flex flex-col gap-3">
        <p className="flex gap-1 flex-wrap text-xs text-gray-700">
          <Trans
            i18nKey={'subscription.trialWarningBanner'}
            values={{
              currentDays: daysSinceStart,
              totalDays: totalTrialDays,
            }}
          >
            <b />
          </Trans>
        </p>
      </div>
    </div>
  );
};
